import {CreateExternalAuthorization, CreateExternalNonce, ExternalAuthorizationId} from "platformed-client/types";
import {platformedClient} from ".";

export async function create(req: CreateExternalAuthorization) {
  return await platformedClient.internalRequest("post", "/region/{region}/api/external_authorizations", {
    path: {},
    body: req,
  });
}

export async function createNonce(externalAuthId: ExternalAuthorizationId, req: CreateExternalNonce) {
  return await platformedClient.internalRequest(
    "post",
    "/region/{region}/api/external_authorizations/{external_authorization_id}/nonce",
    {path: {external_authorization_id: externalAuthId}, body: req},
  );
}
